import React, { useEffect, useState } from 'react';
import {
    Box, Grid, Paper, Typography, Card,
    CardContent, Divider,
} from '@mui/material';
import moment from 'moment';
import { Bar } from 'react-chartjs-2';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';
import { renderAddressMapLink } from './reportMapLinks';

const pieOptions = (title) => {
    return {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: title,
                position: 'top',
                labels: {
                    fontSize: 12,
                    fontStyle: 'bold'
                }
            }
        }
    }
};


const DriveAndStopFuel = ({ reportData }) => {

    const dimentions = useSelector(liveTrackinglayoutSelector);
    const [chartData, setChartData] = useState(null);

    useEffect(() => {

        if (reportData.reportRecords && reportData.reportRecords.length > 0) {
            let dh = 0;
            let sh = 0;
            reportData.reportRecords.forEach(item => {
                if (item.type === 'drive') {
                    dh += item.hours;
                } else if (item.type === 'stop') {
                    sh += item.hours;
                }
            });
            setChartData(
                {
                    labels: [
                        'Drive Hours',
                        'Parking Hours',
                    ],
                    datasets: [{
                        label: 'Hours',
                        data: [dh, sh],
                        backgroundColor: [
                            'RoyalBlue',
                            'DarkGray',
                        ],
                        hoverOffset: 4,
                        barThickness: 40,
                    }]
                }
            );
        }

        console.log("DnS Fuel", reportData);
    }, [reportData]);

    if (reportData && reportData.track && reportData.meta && reportData.reportRecords && chartData) {
        return (
            <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
                <div style={{ margin: '10px', marginRight: '5px' }}>
                    <Grid container spacing={1}>
                        <Grid
                            item
                            container
                            spacing={2}
                            sm={12}
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="stretch"
                        >
                            <Grid item container sm={9}>
                                <Card style={{ backgroundColor: 'White', width: '100%' }} variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" style={{ color: 'RoyalBlue' }}><b>Report Summary</b></Typography>
                                        <Divider />
                                        <br />
                                        <Grid container>
                                            <Grid item sm={2}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                    From
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={10}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                    {`${moment(reportData.reqBody.timeFrom).format('Do MMM YY hh:mm A')}`}
                                                </Typography>
                                                <Typography gutterBottom variant="body1" style={{ color: 'RoyalBlue' }}>
                                                    {renderAddressMapLink({
                                                        address: reportData.track[0].address,
                                                        source: reportData.track[0],
                                                    })}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={2}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                    To
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={10}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                    {`${moment(reportData.reqBody.timeTo).format('Do MMM YY hh:mm A')}`}
                                                </Typography>
                                                <Typography gutterBottom variant="body1" style={{ color: 'RoyalBlue' }}>
                                                    {renderAddressMapLink({
                                                        address: reportData.track[reportData.track.length - 1].address,
                                                        source: reportData.track[reportData.track.length - 1],
                                                    })}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item container sm={3}>
                                <Grid item sm={12}>
                                    <Bar
                                        data={chartData}
                                        height={200}
                                        width={200}
                                        options={{
                                            ...pieOptions('Duration Breakup'), maintainAspectRatio: false, animation: { duration: 0 }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item container sm={3}>
                                <Card style={{ /*backgroundColor: 'rgba(210, 105, 30, 1)',*/ width: '100%', borderColor: 'SaddleBrown', borderStyle: 'solid', borderWidth: '1px' }}>
                                    <CardContent>
                                        <Typography variant="h5" style={{ color: 'SaddleBrown' }}>Route Details</Typography>
                                        <Divider style={{ background: 'SaddleBrown' }} />
                                        <br />
                                        <Grid container spacing={1} direction="row">
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'SaddleBrown', fontSize: 14 }}>
                                                    Distance
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={8}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'SaddleBrown' }}>
                                                    {`${reportData.meta.routeLength.toFixed(2)}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'SaddleBrown', fontSize: 14 }}>
                                                    Period
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={8}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'SaddleBrown' }}>
                                                    {`${reportData.meta.totalDuration}`}
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item container sm={3}>
                                <Card style={{ /*backgroundColor: 'rgba(30, 144, 255,1)',*/ width: '100%', borderColor: 'DodgerBlue', borderStyle: 'solid', borderWidth: '1px' }}>
                                    <CardContent>
                                        <Typography variant="h5" style={{ color: 'DodgerBlue' }}>Duration Breakup</Typography>
                                        <Divider style={{ background: 'DodgerBlue' }} />
                                        <br />
                                        <Grid container spacing={1} direction="row">
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'DodgerBlue' }}>
                                                    Parked Time
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={8}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'DodgerBlue' }} display="inline">
                                                    {`${reportData.meta.stopDuration}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'DodgerBlue', fontSize: 12 }}>
                                                    Drive Time
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={8}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'DodgerBlue', fontSize: 18 }}>
                                                    {`${reportData.meta.driveDuration}`}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item container sm={3}>
                                <Card style={{ /*backgroundColor: 'rgba(65, 105, 225, 1)',*/ width: '100%', borderColor: 'RoyalBlue', borderStyle: 'solid', borderWidth: '1px' }}>
                                    <CardContent>
                                        <Typography variant="h5" style={{ color: 'RoyalBlue' }}>Speed</Typography>
                                        <Divider style={{ background: 'RoyalBlue' }} />
                                        <br />
                                        <Grid container spacing={1} direction="row">
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'DodgerBlue' }}>
                                                    Average Speed
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={8}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'DodgerBlue' }} display="inline">
                                                    {`${reportData.meta.averageSpeed.toFixed(2)} `}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'DodgerBlue' }} display="inline">
                                                    {` Km/h`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'DodgerBlue', fontSize: 12 }}>
                                                    Top Speed
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={8}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'DodgerBlue', fontSize: 18 }} display="inline">
                                                    {`${reportData.meta.topSpeed.toFixed(2)} `}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'DodgerBlue' }} display="inline">
                                                    {` Km/h`}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item container sm={3}>
                                <Card style={{ /*backgroundColor: 'rgba(65, 105, 225, 1)',*/ width: '100%', borderColor: 'SlateBlue', borderStyle: 'solid', borderWidth: '1px' }}>
                                    <CardContent>
                                        <Typography variant="h5" style={{ color: 'SlateBlue' }}>{`Fuel (${reportData.meta.fuelValues[0].tankName})`}</Typography>
                                        <Divider style={{ background: 'SlateBlue' }} />
                                        <br />
                                        <Grid container spacing={1} direction="row">
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'SlateBlue' }}>
                                                    Consumed
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={8}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'SlateBlue' }} display="inline">
                                                    {`${reportData.meta.fuelValues[0].consumption && reportData.meta.fuelValues[0].consumption.toFixed(2)} `}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'SlateBlue' }} display="inline">
                                                    {` Liter`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'SlateBlue', fontSize: 12 }}>
                                                    Mileage
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={8}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'SlateBlue', fontSize: 18 }} display="inline">
                                                    {`${reportData.meta.fuelValues[0].average && reportData.meta.fuelValues[0].average.toFixed(2)} `}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'SlateBlue' }} display="inline">
                                                    {` Km/L`}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                        </Grid>
                        <Grid item sm={12}>
                            <Card>
                                <CardContent>
                                    <Grid container spacing={1}>
                                        <Grid item container sm={12} style={{ backgroundColor: 'Gray' }} spacing={1}>
                                            <Grid item sm={1}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>Status</b></Typography></Grid>
                                            <Grid item sm={2}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>Start</b></Typography></Grid>
                                            <Grid item sm={2}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>End</b></Typography></Grid>
                                            <Grid item sm={2}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>Duration</b></Typography></Grid>
                                            <Grid item sm={5}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>Details</b></Typography></Grid>
                                            <Grid item sm={12}></Grid>
                                        </Grid>

                                        {
                                            reportData.reportRecords.map((item, index) =>
                                                item.type === 'drive' ?
                                                    <Grid item container sm={12} key={index} spacing={1} style={{ backgroundColor: index % 2 === 0 ? 'WhiteSmoke' : 'White' }}>
                                                        <Grid item sm={1}><Typography gutterBottom variant="body1"><b>Drive</b></Typography></Grid>
                                                        <Grid item sm={2}><Typography gutterBottom variant="body1">{`${moment(item.driveStartTime).format('D/M/Y h:mm A')}`}</Typography></Grid>
                                                        <Grid item sm={2}><Typography gutterBottom variant="body1">{`${moment(item.driveEndTime).format('D/M/Y h:mm A')}`}</Typography></Grid>
                                                        <Grid item sm={2}><Typography gutterBottom variant="body1">{item.driveDuration}</Typography></Grid>
                                                        <Grid item sm={5} container>
                                                            <Grid item sm={4}>
                                                                <Typography gutterBottom variant="body2"><b>Distance</b></Typography>
                                                                <Typography gutterBottom variant="subtitle1">{`${item.driveDistance.toFixed(2)} Km`}</Typography>
                                                            </Grid>
                                                            <Grid item sm={4}>
                                                                <Typography gutterBottom variant="body2"><b>Average</b></Typography>
                                                                <Typography gutterBottom variant="subtitle1">{`${item.averageSpeed.toFixed(2)} Km/h`}</Typography>
                                                            </Grid>
                                                            <Grid item sm={4}>
                                                                <Typography gutterBottom variant="body2"><b>Top</b></Typography>
                                                                <Typography gutterBottom variant="subtitle1">{`${item.topSpeed.toFixed(2)} Km/h`}</Typography>
                                                            </Grid>
                                                            <Grid item sm={4}>
                                                                <Typography gutterBottom variant="body2"><b>{item.fuelValues[0].tankName} Consumed</b></Typography>
                                                                <Typography gutterBottom variant="subtitle1">{`${item.fuelValues[0].consumption.toFixed(2)} L`}</Typography>
                                                            </Grid>
                                                            <Grid item sm={4}>
                                                                <Typography gutterBottom variant="body2"><b>{item.fuelValues[0].tankName} Mileage</b></Typography>
                                                                <Typography gutterBottom variant="subtitle1">
                                                                    <span style={{ color: item.fuelValues[0].average < reportData.meta.fuelValues[0].average ? 'Tomato' : 'SlateBlue' }}>
                                                                        <em><b>{`${item.fuelValues[0].average.toFixed(2)} `}</b></em>
                                                                    </span>
                                                                    Km/L
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <Grid item container sm={12} key={index} spacing={1} style={{ backgroundColor: 'WhiteSmoke' }}>
                                                        <Grid item sm={1}><Typography gutterBottom variant="body1">Parking</Typography></Grid>
                                                        <Grid item sm={2}><Typography gutterBottom variant="body1">{`${moment(item.stopStartTime).format('D/M/Y h:mm A')}`}</Typography></Grid>
                                                        <Grid item sm={2}><Typography gutterBottom variant="body1">{`${moment(item.stopEndTime).format('D/M/Y h:mm A')}`}</Typography></Grid>
                                                        <Grid item sm={2}><Typography gutterBottom variant="body1">{item.stopDuration}</Typography></Grid>
                                                        <Grid item container sm={5}>
                                                            <Grid item sm={12}>
                                                                <Typography gutterBottom variant="body2"><b>Location</b></Typography>
                                                                <Typography gutterBottom variant="subtitle1">
                                                                    {renderAddressMapLink({
                                                                        address: reportData.track[item.startIndex].address,
                                                                        source: reportData.track[item.startIndex],
                                                                    })}
                                                                </Typography>
                                                            </Grid>
                                                            {
                                                                item.idleHours > 0 &&
                                                                <div>
                                                                        <Grid item sm={4}>
                                                                            <Typography gutterBottom variant="body2"><b>Idling</b></Typography>
                                                                            <Typography gutterBottom variant="subtitle1">{`${item.idleDuration}`}</Typography>
                                                                        </Grid>
                                                                        <Grid item sm={4}>
                                                                            <Typography gutterBottom variant="body2"><b>{item.fuelValues[0].tankName} Consumed</b></Typography>
                                                                            <Typography gutterBottom variant="subtitle1">{`${item.fuelValues[0].consumption.toFixed(2)} Liters`}</Typography>
                                                                        </Grid>
                                                                        <Grid item sm={4}>
                                                                            <Typography gutterBottom variant="body2"><b>{item.fuelValues[0].tankName} Average</b></Typography>
                                                                            <Typography gutterBottom variant="subtitle1">{`${item.fuelValues[0].average.toFixed(2)} L/Hr`}</Typography>
                                                                        </Grid>
                                                                </div>
                                                            }
                                                        </Grid>
                                                        <Grid item sm={12}><Divider /></Grid>
                                                    </Grid>
                                            )
                                        }
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid item sm={12}><Box style={{ height: '10px' }}></Box></Grid>
                    </Grid>
                </div>
            </Paper>
        );
    } else {
        return null;
    }

}

export default DriveAndStopFuel;
